<template>
    <div>
        <div class="px-4">
            <div class="wrapper-media">
                <iframe class="absolute top-0 left-0"  width="100%" height="100%" :src="getUrlYoutube()" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                </iframe>
            </div>
        </div>

        <div class="flex py-4">
            <img class="w-full" src="@/assets/bg/shadow.svg" alt="" />
        </div>
        <div class="px-4">
            <div class="bg-white px-4 py-4 rounded-xl">
                <div class="text-22 text-blue-1 ">{{campaign.name}}</div>
                <div class="text-gray-1 border-t border-gray-2 pt-4 text-20"  v-html="getCondition()"></div>
            </div>
        </div>
    </div>
</template>

<script>
//helper
import Util from '@/helper/Utility.js';
//component
export default {
    name: "TypeMedia",
    components: {
    },
    props: {
        campaign: Object,
    },
    created: function() {
    },
    methods: {
        getUrlYoutube: function () {
            return "https://www.youtube.com/embed/" + Util.getAllUrlParams(this.campaign.website).v;
        },
        getCondition: function () {
            return Util.newLineToBr(this.campaign.condition);
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    // .campaign-image {
    //     @include baseRatioImg($ratio: 66.66%);
    //     border-radius: 12px;
    //     box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.12);
    //     overflow: hidden;
    // }
    .wrapper-media {
        @include boxRatio($ratio: 66.66%);
        border-radius: 12px;
    }
</style>
